export const muiMenuItemTheme = {
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme }) => ({
        minHeight: 20,
        lineHeight: 1.7,
        [theme.breakpoints.up('lg')]: {
          lineHeight: 1.4,
          padding: 4,
        },
        padding: 0,
        letterSpacing: '-1px',
        background: 'none',
        marginBottom: 8,
        '.MuiTypography-root': {
          fontSize: '14px',
          textDecoration: 'none',
          marginBottom: 0,
          width: '100%',
        },
        '&.Mui-focusVisible': {
          background: 'none',
          marginBottom: 3,
          '.MuiTypography-root': {
            color: theme.palette.kit.text.h,
            paddingBottom: 4,
            borderBottom: `solid 1px ${theme.palette.kit.stroke.gray}`,
          },
        },
        '&:hover': {
          background: 'none',
          color: theme.palette.kit.text.h,

          '.MuiTypography-root': {
            boxSizing: 'border-box',
            color: theme.palette.kit.text.h,
            paddingBottom: 0,
            marginBottom: 0,
          },
        },

        '&.selectItem': {
          padding: 0,
          marginBottom: '10px',
          fontFamily: 'Inter',
          fontSize: '14px',
          lineHeight: '21px',
          color: theme.palette.kit.text.main,
          '&:last-child': {
            marginBottom: 0,
            '&:hover': {
              marginBottom: 0,
            },
          },
          '&:hover': {
            background: 'none',
            color: theme.palette.kit.text.h,
            marginBottom: '10px',
          },
        },
        '&.MuiMenuItem-gutters.Mui-selected': {
          color: theme.palette.kit.text.h,
          background: 'none',
          padding: 0,
          marginBottom: '10px',
          fontFamily: 'Inter',
          fontSize: '14px',
          lineHeight: '21px',
          color: theme.palette.kit.text.main,
          '&:last-child': {
            marginBottom: 0,
            '&:hover': {
              marginBottom: 0,
            },
          },
          '&:hover': {
            background: 'none',
            borderBottom: 'none',
            color: theme.palette.kit.text.h,
            marginBottom: '10px',
            paddingBottom: 0,
          },
        },
      }),
    },
  },
};
